import { Component, OnInit } from '@angular/core';
import { ImageResponse } from 'src/app/models/image.response.model';
import { Users } from 'src/app/models/users.model';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { environment } from 'src/environments/environment.prod';

@Component({
    selector: 'app-my-dashboard-page',
    templateUrl: './my-dashboard-page.component.html',
    styleUrls: ['./my-dashboard-page.component.scss'],
    standalone: false
})
export class MyDashboardPageComponent implements OnInit {
  selectedStyle: any;
  textStyle: string;
  hoveredItem: any;
  avatarCount: number;
  imageResponse = new ImageResponse();
  public uploadFinished = (event) => {
    this.imageResponse.dbPath = event.dbPath;
  }
  isLoading$;
  user: Users;
  constructor(
    public authenticationService: AuthenticationService,
  ) { }


  ngOnInit(): void {
  
    this.authenticationService.getUserDetail$().subscribe(x => {
      this.user = x
    });

  }
  createImgPathBackGround(imagePath: string): { [key: string]: string } {
    return {
      'background-image': `url('${imagePath}')`,
      'background-size': 'cover',
      'background-repeat': 'no-repeat',
    };
  }
  createImgPath = (serverPath: string) => {
    if (serverPath)
      return `${environment.patchUrl}/${serverPath}`;
  }
}
